export enum TabLayout {
  HORIZONTAL = 'horizontal',
  STACKED = 'stacked',
}

export enum SelectorType {
  CIRCLE = 'circle',
  UNDERLINE = 'underline',
}

export enum TabDesign {
  DEFAULT = 'white',
  TRANSPARENT = 'transparent',
  SOLID = 'solid',
  THEMED = 'light',
  PILL = 'pill',
  ICON_CIRCLE = 'icon-circle',
}
